import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import RootRef from '@material-ui/core/RootRef';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import SortableTableHeadCell from 'components/common/SortableTableHeadCell';

import PatientsTableEmpty from './PatientsTableEmpty';
import PatientsTableRow from './PatientsTableRow';

const styles = theme => ({
  paper: {
    position: 'relative',
    width: '100%',   
    height: 'calc(100vh - 250px)',
    overflowX: 'auto',
    overflowY: 'visible',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 140px)',
      transition: theme.transitions.create(['height'], {
        duration: theme.transitions.duration.short,
      }),
    },
  },
  paperMobileFilterExpanded: {
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 274px)',
    },
  },
  table: {
    minWidth: 1100,
  },
  tableHead: {
    position: 'sticky',
    zIndex: 20,
    top: 0,
    '& th:first-child': {
      paddingLeft: 8,
      borderTopLeftRadius: 10,
    },
    '& th:last-child': {
      borderTopRightRadius: 10,
    },
    '& th': {
      position: 'relative',
      zIndex: 1,
    },
    [theme.breakpoints.down('sm')]: {
      top: 0,
    },
  },
  hiddenCell: {
    fontSize: 0,
  },
  cellActions: {
    borderTopRightRadius: 10,
  },
  typography: {
    paddingLeft: 10,
    paddingBottom: 8,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});
const PatientsTable = ({
  items,
  onRowClick,
  classes,
  sort,
  sortBy,
  onSortingChange,
  loading,
  business,
  mobileFilterExpanded,
  onScroll,
  scrollRef,
  count,
}) => (
  <div>
    <Typography className={classes.typography}>
      Patients
      {(loading === 0 || items.length > 0) && (
        ` (${count})`
      )}
    </Typography>
    <RootRef rootRef={scrollRef}>
      <Paper
        onScroll={onScroll}
        className={classNames(classes.paper, {
          [classes.paperMobileFilterExpanded]: mobileFilterExpanded,
        })}
      >
        {(loading === 0 && items.length === 0) &&
          <PatientsTableEmpty />
        }
        {items.length > 0 &&
          <Table className={classes.table}>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell>
                  <SortableTableHeadCell
                    label="Last"
                    sortField="Last Name"
                    sortBy={sortBy}
                    sort={sort}
                    onSortingChange={onSortingChange}
                    loading={loading}
                  />
                </TableCell>
                <TableCell>
                  <SortableTableHeadCell
                    label="First"
                    sortField="First Name"
                    sortBy={sortBy}
                    sort={sort}
                    onSortingChange={onSortingChange}
                    loading={loading}
                  />
                </TableCell>
                <TableCell>DOB, Age</TableCell>
                <TableCell>Gender</TableCell>
                <TableCell>Address</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Insurance</TableCell>
                <TableCell>Sales</TableCell>
                {!onRowClick &&
                  <Fragment>
                    <TableCell
                      padding="none"
                      // colSpan={2}
                      className={classes.cellWatchers}
                    >
                      Watched
                    </TableCell>
                    <TableCell className={classes.cellActions} />
                  </Fragment>
                }
                {/* <TableCell padding="none" className={classes.hiddenCell}>
                  Notification
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map(item => (
                <PatientsTableRow
                  key={item['Record Number']}
                  patient={item}
                  {...onRowClick ? {
                    hover: true,
                    menu: false,
                    onClick: () => { onRowClick(item); },
                  } : {}}
                  business={business}
                />
              ))}
            </TableBody>
          </Table>
        }
      </Paper>
    </RootRef>
  </div>
);

PatientsTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    'Record Number': PropTypes.number.isRequired,
  })).isRequired,
  count: PropTypes.number.isRequired,
  onRowClick: PropTypes.func,
  sort: PropTypes.oneOf(['asc', 'desc']),
  sortBy: PropTypes.string,
  onSortingChange: PropTypes.func,
  loading: PropTypes.number,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  classes: PropTypes.shape({
    paper: PropTypes.string.isRequired,
    paperMobileFilterExpanded: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
    hiddenCell: PropTypes.string.isRequired,
  }).isRequired,
};

PatientsTable.defaultProps = {
  onRowClick: null,
  sort: null,
  sortBy: null,
  onSortingChange: null,
  loading: 0,
  business: {},
};

export default withStyles(styles)(PatientsTable);



// WEBPACK FOOTER //
// ./src/components/patient/PatientsTable/PatientsTable.js